
/**
 * @nullable
 */
export type UpdateCourseDraft200Level = typeof UpdateCourseDraft200Level[keyof typeof UpdateCourseDraft200Level] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200Level = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
